import { render, staticRenderFns } from "./SelectServiceButton.vue?vue&type=template&id=ebab52ae"
import script from "./SelectServiceButton.vue?vue&type=script&lang=js"
export * from "./SelectServiceButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports